import React from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'shared/components/Button/Button'
import { Colors } from 'shared/theme/colors'
import styled from 'styled-components'

import { Sparkles } from '../../components/Icons/Icon'
import { useAnalyticsEvent } from '../../hooks/useAnalyticsEvent'
import { openConsultant } from '../../redux/actions/consultant/consultant'

export function AskAiButton({ iconOnly = false }: { iconOnly?: boolean }) {
  const dispatch = useDispatch()
  const track = useAnalyticsEvent()

  function handleOpen() {
    dispatch(openConsultant())
    track('nav_ask_ai_click')
  }

  return (
    <StyledButton
      ariaLabel="Ask Cai"
      variant="secondary"
      size="medium"
      onClick={handleOpen}
      icon={<img src={Sparkles} alt="" />}
    >
      {iconOnly ? null : 'Ask Cai'}
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  font-size: 16px;
  border: 1px solid ${Colors.lightGray4};
  box-shadow: 0 2px 10px 2px rgba(0, 44, 177, 0.05);
  text-transform: none;
  height: 34px;
  letter-spacing: 0;

  &:hover:not(:disabled) {
    border-color: ${Colors.lightGray4};
  }
`
